import AbstractAPI from '@/services/api/AbstractAPI';

export default class BusinessUnitContactDetailsApi extends AbstractAPI {

  constructor(client, options) {
    super(client, options, '/business-unit-contact-details');
  }

  async getContactDetails() {
    return await this.makeRequest('/', 'get');
  }
}